import { render, staticRenderFns } from "./CampoMoeda.vue?vue&type=template&id=551fb50b&scoped=true"
import script from "./CampoMoeda.vue?vue&type=script&lang=js"
export * from "./CampoMoeda.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "551fb50b",
  null
  
)

export default component.exports